import type {ReactElement} from 'react';
import type {SwipeableReattachWrapperProps} from './swipeable-reattach-wrapper.types';
import {MAX_OPACITY_REDUCTION, OPACITY_DIVISOR, TRANSITION_DURATION_MS} from './swipeable-reattach-wrapper.types';
import {useSwipeToReattach} from '@Components/ai-chat-window/hooks/useSwipeToReattach';

export function SwipeableReattachWrapper({children, onReattach, enabled, className = ''}: SwipeableReattachWrapperProps): ReactElement {
  const {bind, swipeOffset} = useSwipeToReattach(onReattach, enabled);

  return (
    <div
      {...(enabled ? bind() : {})}
      className={className}
      style={{
        transform: swipeOffset ? `translateX(${swipeOffset}px)` : undefined,
        opacity: swipeOffset ? 1 - Math.min(Math.abs(swipeOffset) / OPACITY_DIVISOR, MAX_OPACITY_REDUCTION) : undefined,
        transition: swipeOffset ? 'none' : `transform ${TRANSITION_DURATION_MS}ms cubic-bezier(0.2, 0.9, 0.3, 1), opacity ${TRANSITION_DURATION_MS}ms cubic-bezier(0.2, 0.9, 0.3, 1)`,
        touchAction: 'pan-y',
      }}
    >
      {children}
    </div>
  );
}
